<div class="flex flex-row items-center justify-between my-[30px]">
  <v4-widget-image-caption [img]="orderDetail?.cover_picture?.small_url || '/assets/status/placeholder.png'">
    <div class="image-caption_caption">
      <!-- house title -->
      <div class="cursor-pointer ellipsis-line-2" (click)="toHouse(orderDetail?.house_title)">
        {{ orderDetail?.house_title || '-' }}
      </div>

      <!-- house-type title -->
      <div
        *ngIf="orderDetail?.house_type_title"
        class="cursor-pointer"
        (click)="toHouseType(orderDetail?.house_type_title)"
      >
        {{ orderDetail?.house_type_title }}
      </div>

      <!-- tag -->
      <div class="v4-tag-list items-center" *ngIf="!tagEditing; else editTag">
        <div *ngIf="isConflictOrder" class="v4-tag-item mr-2 py-1">
          <div class="v4-tag conflict">
            {{ 'order.conflict_order' | translate }}
          </div>
        </div>
        <div class="v4-tag-item mr-2 py-1" *ngIf="orderDetail?.pay_on_site">
          <div class="v4-tag !bg-[#ffd88d]/30 !text-[#fb9d11]">{{ 'order_status-ctrip-现付' | translate }}</div>
        </div>
        <div class="v4-tag-item mr-2 py-1" *ngFor="let tag of orderDetail?.reservation_tag">
          <div class="v4-tag" [style.background-color]="tag.color">
            {{ tag.tag_name }}
          </div>
        </div>
        <div class="py-1">
          <button nz-button nzSize="small" class="no-min-width mr-3" (click)="tagEditing = true">
            {{
              (orderDetail?.reservation_tag?.length
                ? 'order_basic-house_card_html-编辑标签'
                : 'order_basic-house_card_html-添加标签'
              ) | translate
            }}
          </button>
        </div>
      </div>
      <ng-template #editTag>
        <nz-select
          class="min-w-[100px]"
          [nzPlaceHolder]="'order.add_tag' | translate"
          nzMode="multiple"
          [nzDropdownMatchSelectWidth]="false"
          [(ngModel)]="tagIds"
          (nzOpenChange)="onTagOpenChange($event)"
          [nzOptions]="optionsOfResTag"
          [nzDropdownRender]="renderTpl"
        ></nz-select>
        <ng-template #renderTpl>
          <nz-divider class="mt-3 mb-3"></nz-divider>
          <div class="px-3 pb-3">
            <a nz-button nzType="link" (click)="toSettingOptionPage()">
              <i nz-icon nzType="setting" nzTheme="outline"></i>
              {{ 'order.manage_tag' | translate }}
              <!-- Manage tags -->
            </a>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </v4-widget-image-caption>
  <!-- 移入 -->
  <div>
    <button nz-button nz-dropdown [nzDropdownMenu]="moveMenu">
      {{ 'order.move_order' | translate }}
      <span nz-icon nzType="down"></span>
    </button>
    <nz-dropdown-menu #moveMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="onClickChangeHouse()">
          {{ 'order.order_change_house' | translate }}
        </li>
        <li nz-menu-item (click)="onClickMoveToOrderbox()">
          {{ 'order_dertail.move_to_orderbox' | translate }}
        </li>
      </ul>
    </nz-dropdown-menu>
    <!-- <v4-custom-select [placeholder]="'order.move_order' | translate">
      <div class="v4-layout-dropdown" style="padding: 0">
        <ul nz-menu>
          <li nz-menu-item (click)="onClickChangeHouse()">
            订单换房
            {{ 'order.order_change_house' | translate }}
          </li>
          <li nz-menu-item (click)="onClickMoveToOrderbox()">
            移入订单盒子
            {{ 'order_dertail.move_to_orderbox' | translate }}
          </li>
        </ul>
      </div>
    </v4-custom-select> -->
  </div>
</div>
